import React from 'react';
import './Spinner.scss';

const Spinner = () => {
    return (
        <div className="containerSpinner">
            <div className="spinner"></div>
        </div>
    );
};

export default Spinner;
